import { MeResolver } from './auth/me.resolver';

export function AppConfiguration(
  $stateProvider,
  $urlRouterProvider,
  $httpProvider,
  $locationProvider,
  jwtOptionsProvider,
) {
  $locationProvider.html5Mode(true).hashPrefix('');

  $stateProvider

    .state('home', {
      url: '/',
      component: 'home',
    })

    .state('login', {
      url: '/login?error',
      component: 'login',
    })

    .state('tokenExpired', {
      url: '/token-expired',
      component: 'tokenExpired',
    })

    .state('app', {
      url: '/app',
      abstract: true,
      component: 'app',
    })

    .state('app.timesheet', {
      url: '/timesheet/:userId',
      component: 'timesheetLayout',
      authenticate: true,
    })

    .state('app.timesheet.weekly', {
      url: '/:year/:week',
      component: 'weeklyTimesheet',
      authenticate: true,
    })

    .state('app.activities', {
      url: '/activities',
      component: 'activities',
      authenticate: true,
    })

    .state('app.members', {
      url: '/members',
      component: 'members',
      authenticate: true,
    })

    .state('app.activityReport', {
      url: '/activityReports/:activity?accessid',
      params: {
        activity: { squash: true, value: null },
      },
      component: 'activityReport',
      authenticate: true,
    })

    .state('app.periodReport', {
      url: '/reports/period/:period',
      component: 'periodReport',
      authenticate: true,
      resolve: {
        me: MeResolver,
      },
    });

  jwtOptionsProvider.config({
    tokenGetter: function () {
      return localStorage.getItem('access_token');
    },
  });

  $httpProvider.interceptors.push('jwtInterceptor');

  $urlRouterProvider.otherwise('/');

  $httpProvider.interceptors.push('HttpErrorsObserver');
}
